import React, {useState, useEffect} from 'react';

const marked = import(/* webpackChunkName: "marked" */'marked');

const Markdown = ({markdown, className}) => {
    const [html, setHtml] = useState(null);

    useEffect(() => {
        marked.then(marked => {
            setHtml(marked.parse(markdown));
        });
    }, [markdown]);

    // Try for ensure the div always re-renders
    return <div className={className}
        dangerouslySetInnerHTML={{__html: html, markdown: markdown}}
        markdown={markdown}
    />;
}

export default Markdown;